"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translation = void 0;
exports.translation = {
    react: { useSuspense: false },
    fallbackLng: ["en-GB", "sv-SE"],
    supportedLngs: ["en-GB", "sv-SE"],
    interpolation: {
        escapeValue: false,
    },
    detection: {
        order: [
            "localStorage",
            "navigator",
            "subdomain",
            "path",
            "cookie",
            "subdomain",
            "queryString",
            "htmlTag",
        ],
        lookupLocalStorage: "currentLanguage",
    },
};
//# sourceMappingURL=translation.js.map